export function header() {
  // Get the header element
  const header = document.querySelector('.page-header');

  // Add white header to pages on load
  const pagesWhiteBg = document.querySelectorAll([
    '.page-template-wp-custom-template-page-text .page-header',
    '.page-template-page-text .page-header',
    '.single-post .page-header',
    '.page-template-page-small-footer .page-header',
  ]);
  pagesWhiteBg.forEach(page => {
    page.classList.add('scrolled', 'scrolled-up', 'scrolled-down');
  });

  // Set the initial scroll position
  let prevScrollPos = window.scrollY;

  // Function to handle scroll events
  function handleScroll() {
    const currentScrollPos = window.scrollY;
    const scrollThreshold = 20; // Threshold for scrolling

    // Check if the user has scrolled down 100px or more
    if ((currentScrollPos > 150 && prevScrollPos < currentScrollPos)) {
      // Add the class for scrolling down
      header.classList.add('scrolled');
      
      header.addEventListener('transitionend', () => {
        header.classList.add('scrolled-down');
      });
    }

    // Check if the prevScrollPos === currentScrollPos
    if (prevScrollPos === currentScrollPos) {
      // Add the class for scrolling down
      header.classList.add('scrolled');
    }

    // Check if the user has scrolled up
    if (currentScrollPos < prevScrollPos) {
      if (Math.abs(currentScrollPos - prevScrollPos) > scrollThreshold) {
        // Add the class for scrolling up
        header.classList.add('scrolled-up');
      }
    } else {
      if (Math.abs(currentScrollPos - prevScrollPos) > scrollThreshold) {
        // Remove the class for scrolling up
        header.classList.remove('scrolled-up');
      }
    }

    // Update the previous scroll position
    prevScrollPos = currentScrollPos;
  }

  const menuOpen = document.querySelector('.page-header__nav-open .wp-element-button');
  const menuClose = document.querySelector('.page-header__nav-close .wp-element-button');
  const pageBody = document.querySelector('body');

  let menuOpenState = false;

  menuOpen.addEventListener('click', () => {
    if (menuOpenState) {
      pageBody.classList.remove('menu-open');
      menuOpenState = false;
    } else {
      pageBody.classList.add('menu-open');
      menuOpenState = true;
    }
  });

  menuClose.addEventListener('click', () => {
    if (menuOpenState) {
      pageBody.classList.remove('menu-open');
      menuOpenState = false;
    } else {
      pageBody.classList.add('menu-open');
      menuOpenState = true;
    }
  });


  [...document.querySelectorAll('.wp-block-navigation-submenu:has(.wp-block-navigation-submenu__toggle)')]?.forEach(submenuToggler => {
    submenuToggler.addEventListener('click', () => {
      if (submenuToggler) {
        submenuToggler.classList.toggle('submenu-open');
      }
    });

  })

  // language switcher
  const langWrapperParent = document.querySelector('.lang-wrapper')?.parentElement;
  const langWrapper = document.querySelector('.lang-wrapper');
  const languageSwitcher = document.querySelector('.lang-toggle a');
  const langDropdown = document.querySelector('.lang-dropdown');
  const closeLangDropdown = document.querySelector('.close-lang a');

  const navWrapperParent = document.querySelector('.page-header__nav-wrapper nav')?.closest('div');

  if (langWrapper) {
    languageSwitcher.addEventListener('click', (e) => {
      e.preventDefault();
      langDropdown.classList.toggle('open');
      languageSwitcher.classList.toggle('open');
    });
  
    closeLangDropdown.addEventListener('click', (e) => {  
      e.preventDefault();
      langDropdown.classList.remove('open');
      languageSwitcher.classList.remove('open');
    }
    );
  
    function moveLangWrapper() {
      const viewportWidth = window.innerWidth;
    
      if (viewportWidth < 1020) {
        navWrapperParent.appendChild(langWrapper);
      } else {
        const children = Array.from(langWrapperParent.children);
        langWrapperParent.insertBefore(langWrapper, children[2]);
      }
    }
  
    moveLangWrapper();
    window.addEventListener('resize', moveLangWrapper);
  }

  // Add the scroll event listener
  window.addEventListener('scroll', handleScroll);
}